import React, { forwardRef } from 'react';
import styles from './Card.module.css';
import { classNames } from '../../utils/helpers';

const Card = forwardRef(({
  children,
  title,
  subtitle,
  headerAction,
  padding = 'md',
  className,
  ...props
}, ref) => {
  return (
    <div ref={ref} className={classNames(styles.card, styles[`padding-${padding}`], className)} {...props}>
      {(title || headerAction) && (
        <div className={styles.header}>
          <div className={styles.headerContent}>
            {title && <h3 className={styles.title}>{title}</h3>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          {headerAction && <div className={styles.headerAction}>{headerAction}</div>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
